<template>
  <div class="dashboard-rentabilidad-socios">
    <p>Informe de Rentabilidad de Socios</p>
    <!-- <p class="description">{{ descripcion }}</p> -->
      <b-table hover
          responsive="sm" 
          class="registro"
          :busy="tableBusy"
          :items="items" 
          :fields="fields">
        <div slot="table-busy" class="text-center">
          <b-spinner class="table-spinner" label="Spinning" />
        </div>
        <!-- <template v-slot:cell(periodo)="data">
          {{ data.item.periodo | fecha }}
        </template> -->
        <template v-slot:cell(rentabilidadNeta)="data">
          {{ data.item.rentabilidadNeta | moneda }}
        </template>
        <template v-slot:cell(pjeSocios)="data">
          {{ data.item.pjeSocios | porcentaje }}
        </template>
        <template v-slot:cell(importeSocios)="data">
          {{ data.item.importeSocios | moneda }}
        </template>
        <template v-slot:cell(saldoPeriodoAnterior)="data">
          {{ data.item.saldoPeriodoAnterior | moneda }}
        </template>
        <template v-slot:cell(subtotal)="data">
          {{ data.item.subtotal | moneda }}
        </template>
        <template v-slot:cell(totalRetiros)="data">
          {{ data.item.totalRetiros | moneda }}
        </template>
        <template v-slot:cell(saldoSocios)="data">
          {{ data.item.saldoSocios | moneda }}
        </template>
        <template v-slot:cell(opciones)="data">
          <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
            <template slot="button-content">
              <i class="fa fa-ellipsis-v"></i>
            </template>
            <b-dropdown-item
                :disabled="data.item.importeRetiros == 0"
                @click.stop="getRetirosSocios(data.item)">
              <i class="fa fa-edit"></i>Consultar Retiros de Socios</b-dropdown-item>
            <b-dropdown-item 
                :disabled="data.item.sueldosSocios == 0"
                @click.stop="getSueldosRetiros(data.item)">
              <i class="fa fa-edit"></i>Consultar Sueldos de Socios</b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      key: 0,
      items: [],
      fields: [
        { key: 'periodo' },
        { 
          key: 'rentabilidadNeta',
          label: 'Rent.Total Negocio',
          class: 'text-right'
        },
        { 
          key: 'pjeSocios',
          class: 'text-right'
        },
        { 
          key: 'importeSocios',
          class: 'text-right'
        },
        { 
          key: 'saldoPeriodoAnterior',
          label: 'Saldo Anterior',
          class: 'text-right'
        },
        { 
          key: 'subtotal',
          label: 'Subtotal',
          class: 'text-right'
        },
        { 
          key: 'totalRetiros',
          label: 'Retiros',
          class: 'text-right'
        },
        { 
          key: 'saldoSocios',
          label: 'Saldo',
          class: 'text-right'
        },
        {
          key: 'opciones',
          label: '',
          class: 'text-center'
        },
      ],

      tableBusy: true
    }
  },
  mounted () {
    this.tableBusy = true;
  },
  methods: {
    actualizado() {
      this.key++;
    },
    getIndicador() {
      this.items = this.$store.getters['indicadoresSocios/informeRentabilidad'];
      this.tableBusy = false;
    },
    getRetirosSocios(item) {
      this.$emit('consultarRetirosSocios', item.periodo);
    },
    getSueldosRetiros(item) {
      this.$emit('consultarSueldosRetiros', item.periodo);
    },
    setTableBusy(tableBusy) {
      this.tableBusy = tableBusy;
    }
  }
}
</script>

<style>
  .dashboard-rentabilidad-socios {
    margin-bottom: 30px;
  }
  .dashboard-rentabilidad-socios p {
    font-size: 0.8em;
    font-weight: 700;
    margin-bottom: 20px;
  }

</style>


